import clsx from 'clsx'
import isString from 'lodash/isString'
import React, { CSSProperties, HTMLProps, ReactNode } from 'react'

import { Background } from '@Components/Background'
import styles from '@Components/Container/styles.module.scss'
import { ReferenceContentFragment } from '@Generated/graphql'

export const Container = ({
  background,
  backgroundColor,
  children,
  className,
  commonContent,
  header,
  priority,
  sizes,
  style,
  text,
  textColor,
  variant = 'default',
  ...props
}: {
  background?: ReferenceContentFragment
  backgroundColor?: string
  children?: ReactNode
  className?: string
  commonContent?: ReactNode
  header?: string | ReactNode
  priority?: boolean
  sizes?: string
  style?: CSSProperties
  text?: string | ReactNode
  textColor?: string
  variant?: 'default' | 'compact' | 'minimal'
} & HTMLProps<HTMLDivElement>) => (
  <div
    className={clsx(
      'container',
      styles.container,
      Boolean(header) && styles.withHeader,
      Boolean(text) && styles.withText,
      variant === 'compact' && styles.variantCompact,
      variant === 'default' && styles.variantDefault,
      variant === 'minimal' && styles.variantMinimal,
      className,
    )}
    style={{
      '--background-color': backgroundColor,
      '--text-color': textColor,
      ...style,
    } as CSSProperties}
    {...props}
  >
    <Background asset={background} priority={priority} sizes={sizes} />
    {commonContent}
    {!commonContent && (header || text) && (
      <div className={clsx('container-top', styles.top)}>
        {header && isString(header)
          ? <p className={clsx('container-header', styles.header)}>{header}</p>
          : <div className={clsx('container-header', styles.header)}>{header}</div>}
        {text && isString(text)
          ? <p className={clsx('container-text', styles.text)}>{text}</p>
          : <div className={clsx('container-text', styles.text)}>{text}</div>}
      </div>
    )}

    {children}
  </div>
)
